module.exports = require("./ak.d.ts");